// extracted by mini-css-extract-plugin
module.exports =  {"list":"a867bdd7c0--list--owDyV","phone":"a867bdd7c0--phone--zfsrX","list-item":"a867bdd7c0--list-item--GuuA8"};